<template>
  <section class="box is-marginless">
    <form autocomplete="off">
      <v-flex grow>
        <v-row>
          <v-col style="flex:1 0 0">
            <v-breadcrumbs class="breadcrumbs"
                           :items="[{text:'Calendar', href:'calendar'}, {text: selectedState.name, href:{name: 'Location', params: {state: selectedState.name}}}, selectedState.regions]">
              <template v-slot:item="{item}">
                <v-breadcrumbs-item v-if="Array.isArray(item)">
                  <v-select class="selected-region-input" label="Selected Region" outlined dense
                            :items="selectedState.regions" item-value="regionId" item-text="name"
                            v-model="selRegion"></v-select>
                </v-breadcrumbs-item>
                <v-breadcrumbs-item v-if="!Array.isArray(item)">
                  <router-link :to="item.href" class='breadcrumb-item'>{{ item.text }}</router-link>
                </v-breadcrumbs-item>
              </template>
              <template v-slot:divider>
                <span class="divider">/</span>
              </template>
            </v-breadcrumbs>
          </v-col>
          <v-spacer></v-spacer>
          <v-col style="flex:1 0 0">
            <div>
              <v-select class="view-dropdown" label="View" dense outlined
                        :items="[{text:'Today', value: 'today'},{text:'List', value: 'list'},{text:'Calendar', value: 'calendar'}]"
                        v-model="currentStyle" @change="switchStyle"></v-select>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <date-picker
                class="date-picker input-date"
                v-model="date"
                placeholder="Select Date"
            />
            <div
                class="control search-button"
                @click="getCalendar()"
            >
              <a class="button is-small is-black">
            <span class="icon is-right">
              <i class="far fa-search"/>
            </span>
              </a>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-expansion-panels>
            <v-expansion-panel
            >
              <v-expansion-panel-header>
                Search Filters
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col class="search-city-container">
                    <v-autocomplete
                        style="flex:0 0 0; width: 250px"
                        class="search-city-input"
                        :loading="loadingCitySearch"
                        :search-input.sync="city"
                        outlined
                        label="Search by city"
                        append-icon=""
                        append-outer-icon="far fa-search"
                        v-model="cityModel"
                        :items="searchCity"
                        type="text"
                        @change="getCalendar()"
                        @click:append-outer="getCalendar()"
                        @keydown.enter="getCalendar()"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="search-host-container">
                    <v-select dense outlined :items="hosts" width="250px" @change="switchHost" label="Search by host"
                              class="search-host-dropdown"/>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-flex>
    </form>
  </section>
</template>
<style scoped>
@media screen and (max-width: 768px) {
  .search-host-container.col * {
    margin: 0 0 !important;
  }

  .date-picker {
    max-width: 80%
  }

  .view-label {
    right: 0 !important;
  }

  search-host-label {
    right: 0 !important;
  }

  .view-menu {
    padding-top: 25px;
    text-align: center !important;
  }
}

.calendar {
  padding: 0 12px;
}

.breadcrumbs {
  text-align: left;
}

.search-host-dropdown {
  max-width: 200px;
}

.search-host-label {
  position: relative;
  right: 120px;
}

.input.is-small {
  height: 40px;
}

.view-dropdown {
  display: inline-block;
  width: 150px
}

.view-menu {
  text-align: right;
}

.search-city-container {
  text-align: left;
}

.date-picker-container {
  text-align: center;
}

.view-label {
  position: relative;
  right: 120px;
  margin-top: -20px
}

.search-button {
  margin-left: .2rem;
  display: inline-block;
}

.date-picker {
  display: inline-block;
}

.breadcrumb-item {
  margin-top: -20px;
}

.divider {
  display: inline-block;
  margin-top: -20px
}

.button.is-small.is-black {
  height: 40px;
}

.v-breadcrumbs.theme--light {
  padding: 0;
  margin: 0;
}
</style>
<style>
@media screen and (max-width: 768px) {
  .selected-region-input .v-label.v-label--active.theme--light {
    left: 74px !important;
  }

  .selected-region-input {
    margin-top: 10px !important;
    width: 250px !important;
  }
}

.search-city-input i {
  font-size: 12px !important;
  color: #FFF !important;
}

.search-city-input .v-text-field__details {
  display: none;
}

.search-city-input.v-input .v-input__icon {
  margin-left: -10px;
  margin-top: -16px;
  height: 56px;
  background-color: #000;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
</style>
<script>
import DatePicker from '../../helpers/Datepicker.vue'
import axios from 'axios'

export default {
  components: {
    DatePicker
  },
  props: ['selectedState', 'selectedRegion', 'hosts', 'selectedHost', 'user', 'selectedStyle'],
  data() {
    return {
      cityModel: null,
      loadingCitySearch: false,
      currentStyle: null,
      selRegion: null,
      date: new Date(),
      city: '',
      searchCity: '',
      dropdownRegion: false,
      dropdownDay: false,
      dropdownMonth: false,
      dropdownStyle: false,
      dropdownHost: false,
      selectedDay: '',
      selectedMonth: ''
    }
  },
  mounted() {
    this.currentStyle = this.selectedStyle
    this.selRegion = this.selectedRegion
  },
  watch: {
    selectedRegion(newValue) {
      this.selRegion = newValue;
    },
    selRegion(newValue) {
      this.setRegion(newValue);
    },
    city(newValue) {
      if (newValue.length > 0) {
        this.search('calendar')
      } else {
        this.searchCity = ''
      }
    }
  },
  methods: {
    showMonth() {
      this.dropdownMonth = !this.dropdownMonth
      this.dropdownRegion = false
      this.dropdownDay = false
    },
    showDay() {
      this.dropdownDay = !this.dropdownDay
      this.dropdownMonth = false
      this.dropdownRegion = false
    },
    showStyle() {
      this.dropdownStyle = !this.dropdownStyle
    },
    showHost() {
      this.dropdownHost = !this.dropdownHost
    },
    getCalendar() {
      this.$emit('setCity', this.cityModel)
      this.$emit('setDate', this.date)
      this.$emit('getCalendar')
    },
    switchStyle(style) {
      this.$emit('switchStyle', style.toLowerCase())
    },
    switchHost(name) {
      this.$emit('selectHost', name)
    },
    setRegion(region) {
      this.$emit('setRegion', region)
    },
    search(route) {
      this.loadingCitySearch = true;
      let url = `general/citysearch/${this.city}`
      this.$axios({
        method: 'GET',
        url
      })
          .then((res) => {
            this.loadingCitySearch = false;
            this.searchCity = res.data.map((city) => {
              return {value: city.fullname, text: city.fullname}
            })
          })
          .catch((error) => {
            this.$emit('message', {error: true, message: error.response.data.message})
          })
    }
  }
}
</script>
